import { Button } from '@mantine/core';
import { Email } from '@carbon/icons-react';
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import CommonStyles from '../CommonStyles.module.scss';

import EmailChangeModal from 'Screens/Dashboard/Settings/Options/EmailChangeButton/EmailChangeModal/EmailChangeModal';

const EmailChangeButton = () => {
    const intl = useIntl();
    const [modalOpen, setModalOpen] = useState(false);

    const onPasswordChangeRequest = () => {
        setModalOpen(true);
    };

    return (
        <>
            <Button
                className={CommonStyles.button}
                variant="light"
                leftSection={<Email size={16} />}
                onClick={onPasswordChangeRequest}
            >
                {intl.formatMessage(messages.iconDescription)}
            </Button>
            <EmailChangeModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
        </>
    );
};

const messages = defineMessages({
    iconDescription: {
        id: 'src.Screens.Dashboard.Settings.SettingsTabs.iconDescription',
        defaultMessage: 'Zmień email',
    },
});

export default EmailChangeButton;
